import { Component, input } from '@angular/core';
import { Size } from '../common/types';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-spinner',
  imports: [Icon],
  template: `
    <section class="flex items-center justify-center w-full h-full">
      <app-icon
        [size]="size()"
        class="spinner-icon animate-spin text-primary-500"
        name="mdi:loading"
      />
    </section>
  `,
  styleUrl: './spinner.component.css',
})
export class Spinner {
  size = input<Size>('md'); // 기본 크기는 'md'로 설정
}
